import { render, staticRenderFns } from "./OnlyOffice.vue?vue&type=template&id=1233b2ae&scoped=true"
import script from "./OnlyOffice.vue?vue&type=script&lang=js"
export * from "./OnlyOffice.vue?vue&type=script&lang=js"
import style0 from "./OnlyOffice.vue?vue&type=style&index=0&id=1233b2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233b2ae",
  null
  
)

export default component.exports